<h2 class="modal-title" mat-dialog-title>
  @if (!data.issues.length) {
    <span>{{ 'CONFIGURATOR|POTWIERDZENIE!' | translate }}</span>
  }
  @if (data.issues.length) {
    <span>{{ 'CONFIGURATOR|WYSTĄPIŁY BŁĘDY!' | translate }}</span>
  }
</h2>
<mat-dialog-content>
  @if (data.shopMessage && !data.issues.length) {
    <h3 class="summary-message">{{'CONFIGURATOR|Konstrukcja została dodana do koszyka' | translate}}</h3>
  }
  @if (!data.shopMessage && data.message) {
    <h3 class="summary-message">{{data.message}}</h3>
  }
  @if (!data.issues.length) {
    <h4 class="summary-txt">{{ 'CONFIGURATOR|Wybierz jedną z poniższych opcji' | translate}}:</h4>
  }
  @if (data.issues.length) {
    <h5 class="summary-txt">{{ 'CONFIGURATOR| Błędy podczas konfiguracji pozycji' | translate}}:</h5>
  }
  <div style="font-size: smaller; text-align: left; margin-bottom: 50px;">
    @for (issue of data.issues; track issue) {
      <span [innerHTML]="(issue.message| translate) + '<br>'"></span>
    }
  </div>
  <div id='obraz'></div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  @for (option of data.actions; track option) {
    <button mat-button [mat-dialog-close]="option">{{ option.title }}</button>
  }
</mat-dialog-actions>
